<template>
  <div class="box" v-if="experienceShow">
    <div class="content">
      <div class="close" @click="$emit('experienceClick')">
        <img :src="close" alt="" />
      </div>
      <div class="download_list">
        <div
          class="download_item"
          v-for="item in downloadList"
          :key="item.id"
          :style="
            item.id == 1 ? 'border-bottom: 1px solid rgba(0,0,0,0.2)' : ''
          "
          @click="downloadApp(item)"
        >
          <img class="download_item_logo" :src="item.logo" alt="" />
          <div class="download_item_right">
            <div>{{ item.title }}</div>
            <div>{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import close from "../../../assets/close.png";
import logo2 from "../../../assets/downloadApp/logo2.png";

export default {
  props: ["experienceShow"],
  setup() {
    return reactive({
      close: close,
      downloadList: [
        {
          id: 1,
          logo: logo2,
          title: "畅居家园",
          content: "Android APP 下载",
          path: "/mobile/downloaduserapp",
        },
        {
          id: 2,
          logo: logo2,
          title: "畅居智慧物业",
          content: "Android APP 下载",
          path: "/mobile/downloadworkapp",
        },
      ],
    });
  },
  methods: {
    downloadApp(item) {
      this.$router.push(item.path);
    },
  },
};
</script>

<style scoped>
.box {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}
.content {
  width: 65vw;
  padding: 20px 48px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 20px;
  background-image: url(../../../assets/experience.png);
  background-size: 100% 200px;
  background-repeat: no-repeat;
  text-align: center;
}
.close {
  position: absolute;
  top: 5%;
  right: 3%;
  cursor: pointer;
}
.close img {
  width: 24px;
}
/*  */
.download_item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.download_item_logo {
  width: 32px;
  margin-right: 10px;
}
.download_item_right {
  text-align: left;
}
.download_item_right div:nth-of-type(1) {
  font-size: 18px;
  color: #333333;
}
.download_item_right div:nth-of-type(2) {
  font-size: 12px;
  color: #3d3d3d;
  margin-top: 8px;
}
</style>
